import * as w from "react";
import { p as _ } from "./index-efd35e77.js";
import { l as T, v as C } from "./index-64063129.js";
var N = function(n, r) {
  if (n.closest)
    return n.closest(r);
  for (var e = Element.prototype.matches ? function(o, i) {
    return o.matches(i);
  } : function(o, i) {
    return o.msMatchesSelector(i);
  }, t = n; t; ) {
    if (e(t, r))
      return t;
    t = t.parentElement;
  }
}, O = function(n) {
  var r = n.createElement("div");
  r.className = "k-ripple";
  var e = n.createElement("div");
  return e.className = "k-ripple-blob", r.appendChild(e), [r, e];
}, y = function(n, r, e) {
  var t = function() {
    e(), n.removeEventListener(r, t, !1);
  }, o = function() {
    return n.addEventListener(r, t, !1);
  };
  return o(), { remove: o };
}, D = function(n, r) {
  return function(e) {
    var t = e.target, o = t.document || t.ownerDocument, i;
    if (r.container ? i = r.container(t) : i = N(t, n), !!i) {
      var l = /focus/i.test(e.type) && i.classList.contains("k-ripple-target");
      if (!l)
        if (!t.classList.contains("k-checkbox") && !t.classList.contains("k-radio")) {
          i.classList.add("k-ripple-target");
          var p = O(o), a = p[0], s = p[1], u = {
            animated: !1,
            released: !1,
            blob: s,
            container: i,
            ripple: a
          }, d = {
            focusin: "focusout",
            keydown: "keyup",
            mousedown: "mouseup",
            pointerdown: "pointerup",
            touchdown: "touchup",
            animationstart: "animationend"
          }[e.type];
          y(e.currentTarget, d, function() {
            return P(u);
          }), i.appendChild(a), window.getComputedStyle(a).getPropertyValue("opacity");
          var c = i.getBoundingClientRect(), v = 0, f = 0;
          /mouse|pointer|touch/.test(e.type) ? (v = e.clientX - c.left, f = e.clientY - c.top) : (v = c.width / 2, f = c.height / 2);
          var b = v < c.width / 2 ? c.width : 0, E = f < c.height / 2 ? c.height : 0, g = v - b, k = f - E, m = 2 * Math.sqrt(g * g + k * k), x = 500;
          if (s.style.width = s.style.height = m + "px", s.offsetWidth < 0)
            throw new Error("Inconceivable!");
          s.style.cssText = `
        width: ` + m + `px;
        height: ` + m + `px;
        transform: translate(-50%, -50%) scale(1);
        left: ` + v + `px;
        top: ` + f + `px;
    `, setTimeout(function() {
            return R(u);
          }, x);
        } else
          e.target.classList.remove("k-ripple-focus"), e.type !== "animationend" && e.target.classList.add("k-ripple-focus");
    }
  };
}, R = function(n) {
  n.animated = !0, L(n);
}, P = function(n) {
  n.released = !0, L(n);
}, L = function(n) {
  if (!(!n.released || !n.animated)) {
    var r = n.blob, e = n.ripple, t = n.container;
    t && y(t, "blur", function() {
      return t.classList.remove("k-ripple-target");
    }), r && (y(r, "transitionend", function() {
      e && e.parentNode && e.parentNode.removeChild(e);
    }), r.style.transition = "opacity 200ms linear", r.style.opacity = "0");
  }
}, U = function(n, r) {
  var e = function(o) {
    return [].concat.apply([], o);
  }, t = e(r.map(function(o) {
    var i = {
      events: ["mousedown", "touchdown"],
      global: !1
    }, l = o.selector, p = o.options, a = p === void 0 ? i : p, s = D(l, a), u = a.events || i.events, d = a.global ? document.body : n;
    return u.forEach(function(c) {
      return d.addEventListener(c, s, !1);
    }), { events: u, options: a, activator: s };
  }));
  return function() {
    if (n) {
      var o = function(i) {
        var l = i.events, p = i.options, a = i.activator, s = p.global ? document.body : n;
        l.forEach(function(u) {
          return s.removeEventListener(u, a, !1);
        });
      };
      t.forEach(o), n = null;
    }
  };
}, h = {
  name: "@progress/kendo-react-ripple",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1686226665,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, M = globalThis && globalThis.__extends || function() {
  var n = function(r, e) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, o) {
      t.__proto__ = o;
    } || function(t, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (t[i] = o[i]);
    }, n(r, e);
  };
  return function(r, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    n(r, e);
    function t() {
      this.constructor = r;
    }
    r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
  };
}(), A = (
  /** @class */
  function(n) {
    M(r, n);
    function r(e) {
      var t = n.call(this, e) || this;
      if (t._element = null, t.removeListeners = function() {
      }, t.registerListeners = function() {
        var i = t._element;
        t.removeListeners();
        var l = U(i, [
          { selector: ".k-button:not(li)" },
          { selector: ".k-list>.k-item,.k-list>.k-list-item", options: { global: !0 } },
          { selector: ".k-checkbox-label,.k-radio-label" },
          {
            selector: ".k-checkbox,.k-radio",
            options: {
              events: ["focusin", "animationend", "click"]
            }
          }
        ]);
        t.removeListeners = l;
      }, typeof T < "u")
        C(h);
      else {
        var o = "License activation failed for ".concat(h.name, `
`);
        o += `The @progress/kendo-licensing script is not loaded.
`, o += "See ".concat(h.licensingDocsUrl, ` for more information.
`), console.warn(o);
      }
      return t;
    }
    return r.prototype.componentDidMount = function() {
      this.registerListeners();
    }, r.prototype.componentDidUpdate = function() {
      var e = this.props.disabled;
      e ? this.removeListeners() : this.registerListeners();
    }, r.prototype.componentWillUnmount = function() {
      this.removeListeners();
    }, r.prototype.render = function() {
      var e = this, t = this.props.className ? "k-ripple-container " + this.props.className : "k-ripple-container";
      return w.createElement("span", { className: t, ref: function(o) {
        e._element = o;
      } }, this.props.children);
    }, r.propTypes = {
      disabled: _.bool
    }, r;
  }(w.PureComponent)
);
export {
  A as R
};
